import { render, staticRenderFns } from "./sopVirtualHblWorkspace.vue?vue&type=template&id=271d2e3c&"
import script from "./sopVirtualHblWorkspace.vue?vue&type=script&lang=js&"
export * from "./sopVirtualHblWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271d2e3c')) {
      api.createRecord('271d2e3c', component.options)
    } else {
      api.reload('271d2e3c', component.options)
    }
    module.hot.accept("./sopVirtualHblWorkspace.vue?vue&type=template&id=271d2e3c&", function () {
      api.rerender('271d2e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/sopVirtualHbl/sopVirtualHblWorkspace.vue"
export default component.exports